import React, { useState, useEffect, useContext } from "react";
import { ShopContext } from "../context/ShopContext";

const PurchasePage = () => {
  const { fetchAllProducts, products } = useContext(ShopContext);

  const localImages = [
    "/banner/sticker.png",
    "/banner/sticker1.png"
  ];

  // Fetch products on mount
  useEffect(() => {
    fetchAllProducts();
  }, [fetchAllProducts]);

  // Find the specific product
  const product = products.find(p => p.handle === 'kodu-tara-sticker') || products[0];

  // If the fetched product has multiple images, use them. Otherwise, use our complete local high-res sticker images!
  const sliderImages = (product?.images && product.images.length > 1)
    ? product.images.map(img => (typeof img === 'string' ? img : img.src))
    : localImages;

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-rotate images every 5 seconds if there are multiple images
  useEffect(() => {
    if (sliderImages.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [sliderImages.length]);

  const [showShopierModal, setShowShopierModal] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow container mx-auto px-4 py-12 max-w-4xl">
        <div className="apple-gloss rounded-3xl p-8 sm:p-10 flex flex-col md:flex-row items-center transition-all duration-300 hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)]">

          {/* Sticker Slider with Discount Badge */}
          <div className="w-full md:w-1/2 flex justify-center -ml-0 md:-ml-5 mb-8 md:mb-0">
            {/* Discount Badge */}
            <div className="relative h-10 top-0 left-0 bg-gradient-to-r from-red-500 to-rose-600 text-white px-3.5 py-1 rounded-xl text-xs font-bold uppercase tracking-wider flex items-center shadow-md">
              %20 İndirim
            </div>
            <div className="relative w-64 sm:w-72 overflow-hidden group">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
              >
                {sliderImages.map((src, index) => (
                  <div key={index} className="w-full flex-shrink-0 flex items-center justify-center p-1">
                    <img
                      src={src}
                      alt={`Kodu Tara Sticker ${index + 1}`}
                      className="w-full h-auto max-h-72 object-contain drop-shadow-md select-none"
                    />
                  </div>
                ))}
              </div>

              {/* Prev / Next Arrows */}
              {sliderImages.length > 1 && (
                <>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentIndex((prev) => (prev === 0 ? sliderImages.length - 1 : prev - 1));
                    }}
                    className="absolute left-1 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full bg-white/90 shadow-md text-gray-700 hover:text-black flex items-center justify-center text-sm font-bold opacity-0 group-hover:opacity-100 transition-opacity"
                    aria-label="Önceki Görsel"
                  >
                    ‹
                  </button>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentIndex((prev) => (prev + 1) % sliderImages.length);
                    }}
                    className="absolute right-1 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full bg-white/90 shadow-md text-gray-700 hover:text-black flex items-center justify-center text-sm font-bold opacity-0 group-hover:opacity-100 transition-opacity"
                    aria-label="Sonraki Görsel"
                  >
                    ›
                  </button>
                </>
              )}

              {/* Dot Navigation */}
              <div className="flex justify-center mt-4 space-x-2">
                {sliderImages.map((_, index) => (
                  <button
                    key={index}
                    className={`w-2.5 h-2.5 rounded-full transition-all ${index === currentIndex ? "bg-black scale-125" : "bg-gray-300 hover:bg-gray-400"
                      }`}
                    onClick={() => setCurrentIndex(index)}
                    aria-label={`Görsel ${index + 1}`}
                  ></button>
                ))}
              </div>
            </div>
          </div>

          {/* Details */}
          <div className="w-full md:w-1/2 md:pl-10">
            <h2 className="text-2xl sm:text-3xl font-bold mb-3 text-gray-900 tracking-tight">
              {product ? product.title : 'Kodu Tara Akıllı QR Sticker'}
            </h2>
            <p className="text-gray-600 text-sm sm:text-base mb-6 leading-relaxed">
              {product?.description || "Aracınıza veya dükkanınıza Kodu Tara sticker’ınızı yapıştırarak insanların size gizlilik içinde ve hızlıca ulaşmasını sağlayın. Kolay kurulum, güvenli iletişim!"}
            </p>

            {/* Price */}
            <div className="flex items-center mb-6">
              <span className="text-3xl font-extrabold text-black mr-3">
                {product ? `${product.variants[0].price.amount} ${product.variants[0].price.currencyCode}` : '299.90 TL'}
              </span>
              <span className="line-through text-gray-400 text-sm font-medium">375.00 TL</span>
            </div>
            <button
              onClick={() => setShowShopierModal(true)}
              className="w-full bg-gradient-to-b from-gray-900 to-black hover:shadow-[0_10px_25px_-5px_rgba(0,0,0,0.35)] text-white py-3.5 rounded-2xl font-bold transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0 flex items-center justify-center gap-2 apple-sheen border border-white/10"
            >
              <span>Hemen Satın Al</span>
            </button>
          </div>
        </div>

        {/* Not: Pazaryeri linkleri (Amazon, Trendyol, Hepsiburada) kullanıcı isteği üzerine şimdilik devre dışı bırakıldı */}
      </main>

      {/* Shopier Webpage-in-Webpage Modal with Apple Glass Aesthetics */}
      {showShopierModal && (
        <div
          className="fixed inset-0 z-50 bg-black/50 backdrop-blur-md flex items-center justify-center p-3 sm:p-6"
          onClick={() => setShowShopierModal(false)}
        >
          <div
            className="bg-white/95 backdrop-blur-2xl rounded-3xl shadow-[0_25px_60px_-15px_rgba(0,0,0,0.3)] border border-white/80 w-full max-w-4xl h-[88vh] flex flex-col overflow-hidden relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100 bg-white/70 backdrop-blur-md">
              <div className="flex items-center gap-2">
                <span className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse"></span>
              </div>
              <div className="flex items-center gap-2">
                <a
                  href="https://www.shopier.com/kodutara/51563404"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-blue-600 hover:text-blue-800 font-semibold px-3 py-1.5 rounded-xl bg-blue-50/80 hover:bg-blue-100/80 border border-blue-100 transition-colors"
                >
                  Yeni Sekmede Aç ↗
                </a>
                <button
                  onClick={() => setShowShopierModal(false)}
                  className="p-1.5 rounded-xl text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors text-lg font-bold leading-none"
                  aria-label="Kapat"
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Embedded Iframe */}
            <div className="flex-1 w-full bg-white relative">
              <iframe
                src="https://www.shopier.com/kodutara/51563404"
                title="Shopier Ödeme Ekranı"
                className="w-full h-full border-0"
                allow="payment"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchasePage;
